import UIListener from '@/UIListener/UIListener';
import ComponentManager from '@/Management/ComponentManager';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ControlFactory from '@/Factories/ControlFactory';

export default class UserBaseUIListener extends UIListener {

    constructor() {
        super();
    }

    public onDetailViewReady(context: DetailViewContext): void {
        this.updateGui(context);
    }

    public onPropertyValueUpdated(context: DetailViewContext, property: string): void {
        if (property === 'IsAlwaysValid') {
            this.updateGui(context);
        }
    }

    public updateGui(context: DetailViewContext): void {
        const isAlwaysValid = context.genericObject.getObservable('IsAlwaysValid')();
        const validFromItem = context.getUIFactory('ValidFrom') as ControlFactory;
        const validUntilItem = context.getUIFactory('ValidUntil') as ControlFactory;

        if (validFromItem) {
            if (isAlwaysValid && validFromItem.isRequired()) {
                validFromItem.isRequired(false);
                validFromItem.isValid(true);
            } else if (!isAlwaysValid && !validFromItem.isRequired()) {
                validFromItem.isRequired(true);
            }

            validFromItem.isEnabled(!isAlwaysValid);
        }
        
        if (validUntilItem)
            validUntilItem.isEnabled(!isAlwaysValid);
    }
}

ComponentManager.setUIListener('UserBaseUIListener', UserBaseUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.UserBaseUIListener', UserBaseUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');